// Popup functionality
export function popups() {
  document.querySelectorAll('a.popup').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const body = document.querySelector('body');
      body.classList.add('popup-opening');
      const target = this.getAttribute('href');
      const popup = document.getElementById('kiterocket-popup');
      const content = popup.querySelector('.popup-content');
      const close = popup.querySelector('.close a');
      content.innerHTML = '';
      const i = document.createElement('img');
      i.setAttribute('src', target);
      content.appendChild(i);
      close.addEventListener('click', function (ec) {
        ec.preventDefault();
        content.innerHTML = '';
        body.classList.remove('popup-open');
        body.classList.remove('popup-opening');
      });

      i.addEventListener('load', function (el) {
        body.classList.add('popup-open');
        body.classList.remove('popup-opening');
      });
    });
  });
}
